import { Component } from "@angular/core";
import { toastrService } from "src/app/services/ux/toastr.service";

@Component({
  templateUrl: "./privacy.component.html",
  styleUrls: ["privacy.css"]
})
export class PrivacyComponent {
  constructor(public toastr: toastrService) {}
}
